import { createSelector } from '@ngrx/store';

import { Action } from '@models/swagger';
import { State } from './reducer';
import { selectPolicyActionsState } from '../selectors';

export const getData = createSelector(selectPolicyActionsState, (state: State) => state.data);

export const getError = createSelector(selectPolicyActionsState, (state: State) => state.error);

export const getLoading = createSelector(selectPolicyActionsState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: Action[]) => T) =>
  createSelector(selectPolicyActionsState, (state: State) => fn(state.data));
